module.exports = __webpack_public_path__ + "ef4a4a9d32d7a064406008eea0ae73dc.svg";